import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface RecipeFileFailureProps extends BaseTemplateProps {
  fileName: string
  errorMessage: string
}

export const RecipeFileFailure: TemplateDefinition<RecipeFileFailureProps> = {
  renderParams: (props: RecipeFileFailureProps) => ({
    messageKey: 'notificationsDomain.templates.recipeFileFailure',
    values: {
      fileName: props.fileName,
      errorMessage: props.errorMessage,
    },
  }),
}
